export type PaymentClass = 'cash' | 'card' | 'other';

/**
 * Mirror of the backend classifier (ReportServiceImpl.paymentClass): split a
 * payment into cash / card / other for the Credit Card and Custom Payment views.
 */
export function paymentClass(paymentType: string | null | undefined, cardType?: string | null): PaymentClass {
  if (cardType) return 'card';
  const t = (paymentType ?? '').toLowerCase();
  if (t.includes('cash')) return 'cash';
  if (/card|credit|debit|visa|master|amex/.test(t)) return 'card';
  return 'other';
}
